import {
    QueryDocCenterListUsingGetParams,
    SupportCenterDoc,
    QueryDocListUsingGetParams,
    QueryLaunchVersionUsingGetParams,
    LaunchVersionVo,
    SelectByPidListUsingGetParams,
    SupportCenterCategory,
    LoadDocUsingGetParams,
    QueryVersionAndCategoryByCategoryIdUsingGetParams,
    VersionAndCategoryVo,
    SupportCenterDocCategory,
    VisitLog,
    LoadLogUsingGetParams,
    LoadDocByDocCodeUsingGetParams
} from '@servicesTypings/companyRequest'
import { QueryRemarkUsingGetParams, RemarkVo } from '@servicesTypings/drpRequest'
import { companyRequest, drpRequest, openCompanyRequest } from '@/utils/request'

// 查询文档中心文档
/**
 * 查询文档中心列表
 */
export function queryDocumentsList(params: QueryDocCenterListUsingGetParams): API.Res<SupportCenterDoc[]> {
    return companyRequest.get('/op/supportCenterDoc/queryDocCenterList', { params })
}

// 查询文档中心文档
/**
 * 查询文档列表
 */
export function queryDocList(params: QueryDocListUsingGetParams): API.Res<SupportCenterDoc[]> {
    return companyRequest.get('/op/supportCenterDoc/queryDocList', { params })
}

// 查询投放版本
/**
 * 查询投放版本
 */
export function queryLaunchVersion(params: QueryLaunchVersionUsingGetParams): API.Res<LaunchVersionVo[]> {
    return companyRequest.get('/op/supportCenterCategory/queryLaunchVersion', { params })
}

// 根据PID查询分类
/**
 * 根据PID查询分类
 */
export function selectByPidList(params: SelectByPidListUsingGetParams): API.Res<SupportCenterCategory[]> {
    return companyRequest.get('/op/supportCenterCategory/selectByPidList', { params })
}

// 查询详情
/**
 * 查询文档
 */
export function queryDocumentsDetail(params: LoadDocUsingGetParams): API.Res<SupportCenterDoc> {
    return companyRequest.get('/op/supportCenterDoc/loadDoc', { params })
}

// 查询详情
/**
 * 根据文档编码查询文档
 */
export function loadDocByDocCode(params: LoadDocByDocCodeUsingGetParams): API.Res<SupportCenterDoc> {
    return openCompanyRequest.get('/open/supportCenterRes/loadDocByDocCode', { params })
}

// 根据二级分类ID查询版本和分类
/**
 * 根据二级分类ID查询版本和分类
 */
export function queryVersionAndCategoryByCategoryId(
    params: QueryVersionAndCategoryByCategoryIdUsingGetParams
): API.Res<VersionAndCategoryVo[]> {
    return companyRequest.get('/op/supportCenterCategory/queryVersionAndCategoryByCategoryId', { params })
}

// 新增文档
/**
 * 插入帮助中心文档
 */
export function createDocuments(data: SupportCenterDoc): API.Res<object> {
    return companyRequest.post('/op/supportCenterDoc/insertDoc', { data })
}

// 更新文档
/**
 * 插入帮助中心文档
 */
export function updateDocuments(data: SupportCenterDoc): API.Res<object> {
    return companyRequest.post('/op/supportCenterDoc/updateDoc', { data })
}

// 删除文档
/**
 * 删除帮助中心文档
 */
export function removeDocuments(data: string): API.Res<object> {
    return companyRequest.post('/op/supportCenterDoc/deleteDoc', { data })
}

// 修改状态
/**
 * 修改文档启用状态
 */
export function updateEnableStatus(data: SupportCenterDoc): API.Res<object> {
    return companyRequest.post('/op/supportCenterDoc/updateEnabledStatus', { data })
}

// 修改文档排序
/**
 * 修改文档排序
 */
export function updateSorted(data: SupportCenterDocCategory): API.Res<object> {
    return companyRequest.post('/op/supportCenterDoc/updateSorted', { data })
}

// 插入客户日志
/**
 * 插入日志
 */
export function insertLog(data: VisitLog): API.Res<object> {
    return companyRequest.post('/op/visitLog/insertLog', { data })
}

// 根据ID查询拜访日志
/**
 * 根据ID查询拜访日志
 */
export function loadLog(params: LoadLogUsingGetParams): API.Res<VisitLog> {
    return companyRequest.get('/op/visitLog/loadLog', { params })
}

// 修改客户日志
/**
 * 修改日志
 */
export function updateLog(data: VisitLog): API.Res<object> {
    return companyRequest.post('/op/visitLog/updateLog', { data })
}

// 根据ID查询拜访日志
/**
 * 查询备注
 */
export function queryRemark(params: QueryRemarkUsingGetParams): API.Res<RemarkVo> {
    return drpRequest.get('/op/companyActiveDetail/queryRemark', { params })
}
